import React from "react"
import PropTypes from "prop-types"
import theme from "styles/theme"
import TextBlock from "components/TextBlock"
import ActionGroup from "components/ActionGroup"

const TextWithSidebar = ({
  title,
  primaryContent,
  sidebarContent,
  actions,
}) => (
  <div
    css={{
      margin: "56px auto 0",
      maxWidth: 942,
    }}
  >
    <h3 css={{ ...theme.t4 }}>{title}</h3>
    <div
      css={{
        display: "grid",
        gridTemplateColumns: "8fr 3fr",
        gridGap: 38,
        [theme.tablet]: { gridGap: 16 },
        [theme.mobile]: {
          display: "block",
        },
      }}
    >
      <TextBlock>{primaryContent}</TextBlock>

      <div>
        <TextBlock>{sidebarContent}</TextBlock>
        {actions && (
          <ActionGroup
            actions={actions}
            colorScheme="dark"
            css={{ "--shadowColor": theme.lightBlue }}
          />
        )}
      </div>
    </div>
  </div>
)

export default TextWithSidebar

TextWithSidebar.propTypes = {
  title: PropTypes.string.isRequired,
  primaryContent: PropTypes.array.isRequired,
  sidebarContent: PropTypes.array.isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    })
  ),
}
